export default "__VITE_PUBLIC_ASSET__4a1ef6a1__"